import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'


Vue.use(VueRouter)

const routes = [
    ...applyRules(['auth'], [{
        path: '/',
        component: () =>
            import ('@/views/default-page'),
        redirect: { name: 'dashboard' },
        children: [
            // General Module
            {
                path: '/',
                redirect: { name: 'dashboard' },
                component: () =>
                    import ('@/views/dashboard/dashboard')
            },
            {
                path: '/dashboard',
                name: 'dashboard',
                component: () =>
                    import ('@/views/dashboard/dashboard')
            },


            // Merchant Module
            {
                path: '/merchant/list',
                name: 'merchant',
                component: () =>
                    import ('@/views/merchant/index')
            },
            {
                path: '/merchant/create',
                name: 'merchant_new',
                component: () =>
                    import ('@/views/merchant/create')
            },
            {
                path: '/merchant/edit/:id',
                name: 'merchant_edit',
                component: () =>
                    import ('@/views/merchant/update')
            },

            // Member Module
            {
                path: '/member/list',
                name: 'member',
                component: () =>
                    import ('@/views/member/index')
            },
            {
                path: '/member/create',
                name: 'member_new',
                component: () =>
                    import ('@/views/member/create')
            },
            {
                path: '/member/:user_id',
                name: 'member_detail',
                component: () =>
                    import ('@/views/member/detail')
            },

            // Banner Module
            {
                path: '/banner/list',
                name: 'banner',
                component: () =>
                    import ('@/views/banner/index')
            },
            {
                path: '/banner/create',
                name: 'banner_new',
                component: () =>
                    import ('@/views/banner/create')
            },
            {
                path: '/banner/edit/:id',
                name: 'banner_edit',
                component: () =>
                    import ('@/views/banner/edit')
            },

            // Order Module
            {
                path: '/order/list',
                name: 'order',
                component: () =>
                    import ('@/views/order/index')
            },

            // Project Module
            {
                path: '/project',
                name: 'project',
                component: () => import ('@/views/project/index'),                
            },
            {
                path:'/project/add_project',
                name:'add_project',
                component: () => import ('@/views/project/addProject')
            },

            {
                path:'/project/edit_project/:id',
                name:'edit_project',
                component: () => import ('@/views/project/editProject')
            },

            // Template Module
            {
                path: '/template',
                name: 'template',
                component: () => import ('@/views/template/index'),                
            },
            {
                path:'/template/add_template',
                name:'add_template',
                component: () => import ('@/views/template/addTemplate')
            },

            {
                path:'/template/edit_template/:id',
                name:'edit_template',
                component: () => import ('@/views/template/editTemplate')
            },

             // Subscriber Module
            {
                path: '/subscriber',
                name: 'subscriber',
                component: () => import ('@/views/subscriber/index'),                
            },
            {
                path:'/subscriber/add_subscriber',
                name:'add_subscriber',
                component: () => import ('@/views/subscriber/addSubscriber')
            },

            {
                path:'/subscriber/view_subscriber/:id',
                name:'view_subscriber',
                component: () => import ('@/views/subscriber/viewSubscriber')
            },

            {
                path:'/subscriber/reset_password/:id',
                name:'reset_password',
                component: () => import ('@/views/subscriber/resetPassword')
            },

            //User Module
            {
                path: '/user',
                name: 'user',
                component: () => import ('@/views/user/index'),                
            },
            {
                path:'/user/add_user',
                name:'add_user',
                component: () => import ('@/views/user/addUser')
            },
            
            {
                path:'/user/view_user/:id',
                name:'view_user',
                component: () => import ('@/views/user/viewUser')
            },
            {
                path:'/user/reset_password/:id',
                name:'reset_password',
                component: () => import ('@/views/user/resetPassword')
            },
            //AdZone Module
            {
                path: '/adzone',
                name: 'adzone',
                component: () => import ('@/views/adzone/index'),               
            },
            {
                path:'/adzone/add_adzone',
                name:'add_adzone',
                component: () => import ('@/views/adzone/addAdZone')
            },
            {
                path:'/adzone/view_adzone/:id',
                name:'view_adzone',
                component: () => import ('@/views/adzone/viewAdZone')
            },
              //AdPlacement Module
              {
                path: '/adplacement',
                name: 'adplacement',
                component: () => import ('@/views/adplacement/index'),            
            },
            {
                path:'/adplacement/add_adplacement',
                name:'add_adplacement',
                component: () => import ('@/views/adplacement/addAdPlacement')
            },
            {
                path:'/adplacement/view_adplacement/:id',
                name:'view_adplacement',
                component: () => import ('@/views/adplacement/viewAdPlacement')
            },
            //Ad Module
            {
                path: '/ad',
                name: 'ad',
                component: () => import ('@/views/ad/index'),            
            },
            {
                path:'/ad/add_ad',
                name:'add_ad',
                component: () => import ('@/views/ad/addAd')
            },
            {
                path:'/ad/view_ad/:id',
                name:'view_ad',
                component: () => import ('@/views/ad/viewAd')
            },
            //Ads Count&Count Detail Listing 
            {
                path: '/adcount',
                name: 'adcount',
                component: () => import ('@/views/adcount/index'),            
            },
            //Presta
            {
                path: '/presta',
                name: 'presta',
                component: () => import ('@/views/adcountpresta/index'),            
            },
            //Agent
            {
                path: '/agent',
                name: 'agent',
                component: () => import ('@/views/agent/index'),            
            },
        
        ]
    }]),


    ...applyRules(['guest'], [{
        path: '/',
        component: () =>
            import ('@/views/guest-page'),
        children: [{
                path: '/login',
                name: 'login',
                component: () =>
                    import ('@/views/auth/login'),
            }

        ]
    }, ]),


    {
        path: '*',
        name: 'error',
        component: () =>
            import ( /* webpackChunkName: "error" */ '@/views/error-page')
    }

    // {
    //   path: '/about',
    //   name: 'About',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    // }
]

function applyRules(rules, routes) {
    for (let i in routes) {
        routes[i].meta = routes[i].meta || {}

        if (!routes[i].meta.rules) {
            routes[i].meta.rules = []
        }
        routes[i].meta.rules.unshift(...rules)

        if (routes[i].children) {
            routes[i].children = applyRules(rules, routes[i].children)
        }
    }
    return routes
}

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes
})

const rules = {
    guest: { fail: 'dashboard', check: () => (!store.getters['auth/check']) },
    auth: { fail: 'login', check: () => (store.getters['auth/check']) },
}

router.beforeEach(async(to, from, next) => {

    // Token exist, api call to check login status
    if (store.getters['auth/token']) {
        try {
            // use store to call api
            await store.dispatch('auth/fetchUser');
        } catch (e) {

        }
    }

    // Route rules meta exist, check rules
    let route = false;

    (await to.meta.rules) &&
        to.meta.rules.forEach(rule => {
            let check = false;

            // check store user data exist
            check = rules[rule].check();

            if (!check) {
                //if auth/guest allow to use guess page
                if (rule == "auth") {
                    route = rules[rule].fail;
                }
            }
        });

    if (route) {
        return next({ name: route });
    } else {
        return next();
    }
});

export default router